export default "/assets/images/basic-breather-crop.025a273ab367e0fe.png";